<template>
  <protected-pages-layout>
  <div class="wrapper">
    <!-- <navbar> </navbar> -->
    <h3 style="margin-top: 40px; width: 100%; text-align: center;">{{ team.Name }}</h3>
    <div class="row" style="margin-top: 30px">
      <div class="col-md-5 offset-md-1">
        <div class="card">
          <h4 style="margin-top: 20px">Members</h4>
          <table class="table table-borderless" style="margin-top: 20px">
            <thead>
              <tr>
                <th>Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(member, index) in teamMembers" v-bind:key="index">
                <td>{{ member.userName }}</td>
                <td>
                  <font-awesome-icon
                    icon="trash-alt"
                    class="delete-button"
                    @click="
                      removeTeamMember(
                        member.id,
                        router.currentRoute.value.params.id,
                      )
                    "
                    color="rgba(44, 62, 80, 0.43)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-5">
        <div class="card">
          <h4 style="margin-top: 20px">Other users</h4>
          <table class="table table-borderless" style="margin-top: 20px">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(member, index) in notTeamMembers" v-bind:key="index">
                <td>{{ member.Name }}</td>
                <td>
                  <font-awesome-icon
                    icon="plus"
                    class="add-button"
                    @click="
                      addTeamMember(
                        member.ID,
                        router.currentRoute.value.params.id,
                      )
                    "
                    color="rgba(44, 62, 80, 0.43)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  </protected-pages-layout>
</template>

<script setup>
import { onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useTeamStore } from "../stores/team.js";
import router from "../router/index.js";

const teamStore = useTeamStore();

const {
  getTeam: team,
  getTeamMembers: teamMembers,
  getNotTeamMembers: notTeamMembers,
} = storeToRefs(teamStore);

const { fetchTeamVue, addTeamMember, removeTeamMember } = teamStore;

onMounted(async () => {
  await fetchTeamVue(router.currentRoute.value.params.id);
});
</script>

<script>
import Navbar from "../components/Navbar.vue";
export default {
  components: {
    navbar: Navbar,
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
}

.card {
  padding: 10px;
}
.delete-button:hover {
  color: rgba(225, 85, 84, 1);
  cursor: pointer;
}

.add-button:hover {
  color: rgba(59, 178, 115, 1);
  cursor: pointer;
}

#team_name_input {
  outline: 0px !important;
  --webkit-appearance: none;
}

td {
  border: none;
}

th {
  border-top: none;
}
</style>
